import React from 'react';
import Zoom from 'react-medium-image-zoom';
// import 'react-medium-image-zoom/dist/styles.css';
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
import 'react-medium-image-zoom/dist/styles.css';
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';
import { Row } from 'antd';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, styled } from '@mui/material';
import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon, Close as CloseIcon, RotateLeft as RotateLeftIcon, RotateRight as RotateRightIcon, ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import Utils from '../../utils';

const StyledGalleryWrapper = styled('div')(({ }) => ({
  '& .MuiSvgIcon-root': {
    'color': "black",
    'height': 'calc(var(--fs-sm)*2)',
    'width': 'calc(var(--fs-sm)*2)',
    'borderRadius': 'calc(var(--sp-lg)*1.4150)',
    'background': 'white',
    'padding': 'calc(var(--sp-xxs)*0.5)'
  },
  '& .image-gallery': {
    maxHeight: '100%',
  },
  '& .image-gallery-content': {
    height: '100%',
  },
  '& .image-gallery-slide-wrapper ': {
    height: '55%',
    width: '100%',
    // backgroundColor:"rgba(224, 222, 235, 1)",
    borderRadius: 'calc(var(--sp-xxs)*2)',
  },
  '& .image-gallery-swipe': {
    height: '100%'
  },
  '& .image-gallery-slides': {
    height: '100%'
  },
  '& .image-gallery-slide': {
    height: '100%'
  },
  '& .image-gallery-slide .image-gallery-image': {
    height: '50vh',
    objectFit: 'contain',
  },
  '& .image-gallery-thumbnails': {
    paddingTop: 'calc(var(--sp-md)*2)',
  },
  '& .image-gallery-thumbnail': {
    border: '4px solid rgba(224, 222, 235, 1) !important',
    backgroundColor: 'rgba(224, 222, 235, 1)',
    borderRadius: 'calc(var(--sp-xxs)*2)',
  },
  '& .image-gallery-thumbnail+.image-gallery-thumbnail': {
    marginLeft: '0'
  },
  '& .image-gallery-thumbnails-container': {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "13px"
  },
  '& .image-gallery-thumbnail .image-gallery-thumbnail-inner': {
    borderRadius: 'calc(var(--sp-xxs)*2)',
  },
}));

const ZoomWrapper = styled('div')(({ theme }) => ({
  '& .react-transform-component': {
    [theme.breakpoints.down('md')]: {
      height: '100vh !important'
    }
  }
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    '& .MuiDialogContent-root': {
      overflowY: 'hidden'
    },
    '& .MuiDialog-paper': {
      maxWidth: '80% !important',
      maxHeight: 'calc(100% - -246px) !important',
      // marginTop: '320px'
    },
    '& .MuiDialog-container': {
      overflowY: 'auto !important',
    },
    '& img': {
      maxHeight: 'calc(var(--fs-hero)*18.86792)',
      maxWidth: 'calc(var(--fs-hero)*18.86792)'
    },
  },
  '& .MuiDialogContent-root': {
    overflowY: 'hidden',
    padding: '0 !important'
  }
}));

const renderImage = (item, rotation = 0) => {
  return (
    <Zoom style={{ width: '100%' }}>
      <ZoomWrapper>
        <Row justify="center">
          <TransformWrapper options={{
            limitToBounds: true,
          }}>
            <TransformComponent wrapperStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
            }}>
              <img
                src={item.original}
                alt={item.original}
                style={{
                  width: 'auto',
                  height: 'auto',
                  minHeight: 'max(calc(95vh - 20px), calc(60vh - 80px))',
                  maxWidth: 'max(calc(95vw - 40px), calc(60vw - 80px))',
                  // maxHeight: 'calc(86vh - 80px) !important',
                  cursor: "zoom-in",
                  objectFit: "contain",
                  background: "#fff",
                  transform: `rotate(${rotation}deg)`,
                  transition: 'transform 0.3s ease'
                }}
              />
            </TransformComponent>
          </TransformWrapper>
        </Row>
      </ZoomWrapper>
    </Zoom>
  );
};

class ImageSliderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.myImageRef = React.createRef();
    this.onFullscreen = this.onFullscreen.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onMoveToSlide = this.onMoveToSlide.bind(this);
    this.showThumbnails = props.showThumbnails;
    this.showBullets = props.showBullets;
    this.fullScreen = props.fullScreen
    this.state = {
      images: [],
      clickedImage: null,
      showModal: false,
      imageSize: 500,
      rotation: 0,
      currentImageUrl: null
    };
  }

  onFullscreen() {
    this.myImageRef.current.fullScreen();
  }
  onPlay() {
    this.myImageRef.current.play();
  }
  onPause() {
    this.myImageRef.current.pause();
  }
  onMoveToSlide() {
    // Index start from 0 so 2 will move to 3rd slide
    this.myImageRef.current.slideToIndex(2);
  }
  componentDidMount() { }

  onImgLoad(target) {
    this.setState({ imageSize: target?.nativeEvent?.srcElement?.naturalWidth || 500 });
  }

  handleImageClick = (event, data) => {
    const clickedImage = event.target;
    this.setState({
      showModal: true,
      clickedImage
    });
  };

  onClose = () => {
    this.setState({
      showModal: false
    });
  }
  rotateClockwise = () => {
    this.setState(prev => ({ rotation: prev.rotation + 90 }));
  };

  rotateCounterClockwise = () => {
    this.setState(prev => ({ rotation: prev.rotation - 90 }));
  };

  handleCopyImage = async () => {
    try {
      const imageUrl = this.state.currentImageUrl || (this.state.clickedImage?.src);
      if (!imageUrl) {
        console.error('No image URL available');
        return;
      }

      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          canvas.toBlob(async (blob) => {
            try {
              await navigator.clipboard.write([
                new ClipboardItem({ [blob.type]: blob })
              ]);
              console.log('Image copied to clipboard successfully');
              Utils.showAlert(1, 'Image copied');

            } catch (clipboardError) {
              console.error('Clipboard API error:', clipboardError);
            }
          }, 'image/png');
        } catch (canvasError) {
          console.error('Canvas error:', canvasError);
        }
      };

      img.onerror = () => {
        console.error('Failed to load image:', imageUrl);
      };

      img.src = imageUrl;
    } catch (error) {
      console.error('Failed to copy image:', error);
    }
  };

  handleSlideChange = (index) => {
    if (this.props.images && this.props.images[index]) {
      this.setState({ currentImageUrl: this.props.images[index].image });
    }
  };


  render() {
    let images = this.props.images?.map((data, i) => ({ id: i, original: data.image, thumbnail: data.image })) || [];
    let selectedId = images.filter((data) => data.original === this.state.clickedImage?.src)?.[0]?.id;
    let orderChangedImages = selectedId ? [...images.slice(selectedId), ...images.slice(0, selectedId)] : [...images];
    return (
      <StyledGalleryWrapper style={{ cursor: 'pointer', ...this.props.style, height: "60%", marginRight: "10px" }} className="gallery-wrapper">
        <ImageGallery
          items={images}
          ref={this.myImageRef}
          onClick={(e, data) => this.handleImageClick(e, data)}
          lazyLoad={true}
          showFullscreenButton={false}
          showPlayButton={false}
          showThumbnails={this.showThumbnails || false}
          showBullets={this.showBullets || false}
          renderLeftNav={(onClick, disabled) => (
            <Button color='primary' onClick={onClick} disabled={disabled} style={{ position: 'absolute', bottom: '40%', left: 'var(--sp-xs)', zIndex: '999', borderRadius: 'calc(var(--sp-lg)*2.35849)' }}>
              <ArrowBackIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
            </Button>
          )}
          renderRightNav={(onClick, disabled) => (
            <Button color='primary' onClick={onClick} disabled={disabled} style={{ position: 'absolute', bottom: '40%', right: 'var(--sp-xs)', zIndex: '999', borderRadius: 'calc(var(--sp-lg)*2.35849)' }}>
              <ArrowForwardIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
            </Button>
          )}
        />
        <BootstrapDialog fullScreen={this.fullScreen} open={this.state.showModal} onClose={this.onClose}>

          <IconButton
            aria-label="close"
            onClick={this.onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 'max(12px, calc(env(safe-area-inset-top) + 8px))',
              color: '#000',
              zIndex: '999',
              backgroundColor: 'white',
             '&:hover': { backgroundColor: '#000', color: '#fff' }
            }}
          >
            <CloseIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
          </IconButton>

          <div
            style={{
              position: "absolute",
              top: 'max(12px, calc(env(safe-area-inset-top) + 8px))',
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "10px",
              zIndex: 999,
            }}
          >
            <IconButton
              aria-label="rotate counterclockwise"
              onClick={this.rotateCounterClockwise}
              sx={{
                color: "#000",
                backgroundColor: "white",
                '&:hover': { backgroundColor: '#000', color: '#fff' }
              }}
            >
              <RotateLeftIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
            </IconButton>

            <IconButton
              aria-label="rotate clockwise"
              onClick={this.rotateClockwise}
              sx={{
                color: "#000",
                backgroundColor: "white",
                '&:hover': { backgroundColor: '#000', color: '#fff' }
              }}
            >
              <RotateRightIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
            </IconButton>

            <IconButton
              aria-label="copy image"
              onClick={this.handleCopyImage}
              sx={{
                color: "#000",
                backgroundColor: "white",
                '&:hover': { backgroundColor: '#000', color: '#fff' }
              }}
            >
              <ContentCopyIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
            </IconButton>
          </div>

          <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: "30vh", minWidth: '30vw' }}>
            {this.state.clickedImage && (
              <ImageGallery
                additionalClass='image-gallery-slide-modal'
                items={orderChangedImages}
                showThumbnails={false}
                onSlide={(index) => this.handleSlideChange(index)}
                renderItem={(item) => renderImage(item, this.state.rotation)}
                ref={this.myImageRef}
                lazyLoad={true}
                showFullscreenButton={false}
                showPlayButton={false}
                showBullets={this.showBullets || false}
                renderLeftNav={(onClick, disabled) => (
                  <IconButton color='primary' onClick={onClick} disabled={disabled} style={{ position: 'absolute', bottom: '40%', left: 'var(--sp-xs)', zIndex: '999', borderRadius: 'calc(var(--sp-lg)*2.35849)', backgroundColor: 'white' }}>
                    <ArrowBackIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
                  </IconButton>
                )}
                renderRightNav={(onClick, disabled) => (
                  <IconButton color='primary' onClick={onClick} disabled={disabled} style={{ position: 'absolute', bottom: '40%', right: 'var(--sp-xs)', zIndex: '999', borderRadius: 'calc(var(--sp-lg)*2.35849)', backgroundColor: 'white' }}>
                    <ArrowForwardIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)' }} />
                  </IconButton>
                )}
              />
            )}
          </DialogContent>
        </BootstrapDialog>

      </StyledGalleryWrapper>
    );
  }
}
export default ImageSliderComponent;
